<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='轮播列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="showAddDialog">添加轮播</el-button>
        </el-col>
      </el-row>
      <el-table :data="carouselList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="pic" label="封面" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.pic"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <carousel-add :visible="addDialogAvaible"
      :id="currentId"
      @add="addCarousel"
      @update="updateCarousel"
      @closeDialog="closeAddDialog"></carousel-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import CarouselAdd from './CarouselAdd.vue'
export default {
  name: 'carousel_list',
  components: {
    'bread-crumb': BreadCrumb,
    'carousel-add': CarouselAdd
  },
  created () {
    this.getCarouselList()
  },
  data () {
    return {
      currentId: 0,
      carouselList: [],
      addDialogAvaible: false
    }
  },
  methods: {
    async getCarouselList () {
      const res = await this.$http.get('/admin/carousel/list')
      if (res.code === 0) {
        this.carouselList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async addCarousel (data) {
      const res = await this.$http.post('/admin/carousel/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getCarouselList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateCarousel (id, data) {
      const res = await this.$http.post('/admin/carousel/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getCarouselList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/carousel/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getCarouselList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
